import { C as CosmosAvatar$1, d as defineCustomElement$1 } from './p-D-CRpVhT.js';

const CosmosAvatar = CosmosAvatar$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosAvatar, defineCustomElement };
